import script from "./VuePicture.vue?vue&type=script&setup=true&lang=js"
export * from "./VuePicture.vue?vue&type=script&setup=true&lang=js"

import "./VuePicture.vue?vue&type=style&index=0&id=cccf675e&lang=scss"

const __exports__ = script;

export default __exports__